import { isValidDateTimeRangeBetween } from './isValidDateTimeRangeBetween';
import { START_TIME, END_TIME } from 'constants/MeshbotConstant';
import { getParameterByName } from 'helpers/arrayUtils';

/**
 * Validates datetime range parameters for Custom Time trigger
 * If both start and end times exist, validates that start is before end
 * If only one time exists, considers it valid
 * @param {Array<{name: string, value: *}>} parameters - Array of parameter objects
 * @returns {boolean} True if datetime range is valid, false otherwise
 * @example
 * // Valid: only start time
 * isValidDateTimeRange([{ name: 'startTime', value: '09:00' }]) // returns true
 *
 * // Valid: start time before end time
 * isValidDateTimeRange([
 *     { name: 'startTime', value: '09:00' },
 *     { name: 'endTime', value: '17:00' }
 * ]) // returns true
 *
 * // Invalid: no time parameters
 * isValidDateTimeRange([]) // returns false
 */
export function isValidDateTimeRange(parameters) {
    const startTime = getParameterByName(parameters, START_TIME);
    const endTime = getParameterByName(parameters, END_TIME);

    if (startTime && endTime) {
        return isValidDateTimeRangeBetween(parameters);
    }

    return !!(startTime?.value || endTime?.value);
}
